// ConversaoMAT, MAT
export const VITALICIA_S_R_RCM = 'Vitalícia sem reversão em RCM';
export const VITALICIA_C_R_RCM = 'Vitalícia com reversão em RCM';
export const CONJUGADA_S_R_RCM = 'Conjugada sem reversão em RCM';
export const CONJUGADA_C_R_RCM = 'Conjugada com reversão em RCM';

// MAT
export const TEMPORARIA_FIXO = 'Temporária em valor certo';
export const TEMPORARIA_VARIAVEL = 'Temporária em valor variável (cotas)';

// Recebimento correspondencia
export const SEM_JORNAL = 'Não desejo receber Jornal Forluz impresso.';
export const SEM_CORRESPONDENCIA =
  'Não desejo receber nenhuma correspondencia impressa.';
